export default "__VITE_ASSET__B445Up8s__"